<template>
  <section
    class="flex items-center justify-center w-full h-full left-0 top-0 z-10"
    :class="{
      'bg-gray-4': overlay,
      'w-full': overlay,
      'z-10': overlay,
      fixed: overlay,
      absolute: !overlay,
      'pointer-events-none': scrollableBackground,
    }"
    :style="scrollableBackground ? { overflow: 'auto' } : {}"
    @click.self="closeModal('closeOverlay')"
    data-qa="god-modal-overlay"
  >
    <div
      :class="
        'modal-window flex flex-col relative rounded-lg ' +
        windowClass +
        (scrollableBackground ? ' pointer-events-auto' : '')
      "
      :style="{
        height: fullscreen ? '100vh !important' : height,
        width: fullscreen ? '100vw !important' : width,
        maxHeight: fullscreen ? '100vh !important' : null,
      }"
      @click.stop
    >
      <div
        class="w-full flex justify-start items-center"
        v-if="title"
        :style="{
          height: '68px',
          paddingTop: $isMobile ? '17px' : false,
          paddingBottom: $isMobile ? '17px' : false,
          paddingLeft:
            mainContentPadding && mainContentPadding.includes(' ')
              ? mainContentPadding.split(' ')[1]
              : mainContentPadding,
          paddingRight:
            mainContentPadding && mainContentPadding.includes(' ')
              ? mainContentPadding.split(' ')[1]
              : mainContentPadding,
        }"
      >
        <img
          alt="arrow-left"
          src="../assets/img/arrow-left-icon.png"
          @click="$emit('on-back')"
          v-if="back"
          class="pr-2 cursor-pointer"
        />
        <h3
          class="font-medium lg1024:text-2xl text-xl mr-auto"
          v-if="title"
          v-html="title"
        ></h3>
        <slot name="header"></slot>
        <img
          alt="close-icon"
          src="../assets/img/close-icon.png"
          v-if="closeOnButtonClick"
          @click="closeModal('closeButton')"
          class="cursor-pointer close-modal-button bg-white"
          data-qa="god-modal-close-btn"
        />
      </div>
      <div
        class="modal-window__content overflow-y-auto overflow-x-hidden"
        :class="{
          flex: fullscreen,
          'items-center overflow-y-auto': fullscreen,
          'h-full': fullscreen,
        }"
        :style="{
          paddingLeft: mainContentPadding,
          paddingRight: mainContentPadding,
          paddingTop: 0,
        }"
      >
        <slot></slot>
      </div>
      <div
        class="modal-window__footer flex flex-col sm640:flex-row mt-4 lg1024:px-8 px-4 lg1024:mb-6 mb-4"
        v-if="Object.keys(callbackFunctions).length"
      >
        <a
          class="checkout-button modal-window__button text-center focus:outline-none cursor-pointer bg-accentColor text-white p-3 border-2 border-accentColor"
          :class="[
            buttonClasses ? buttonClasses.mainButton : null,
            { 'opacity-50': mainButtonDisabled === true },
          ]"
          :disabled="mainButtonDisabled === true"
          v-if="callbackFunctions.mainButton"
          @click="executeButtonEvent('mainButton')"
          data-qa="god-modal-main-btn"
        >
          {{ buttonNames.mainButton }}
        </a>
        <a
          class="checkout-button checkout-button-second modal-window__button focus:outline-none cursor-pointer text-center p-3 sm640:ml-4"
          :class="[buttonClasses ? buttonClasses.secondaryButton : null]"
          v-if="callbackFunctions.secondaryButton"
          @click="executeButtonEvent('secondaryButton')"
          data-qa="god-modal-secondary-btn"
        >
          {{ buttonNames.secondaryButton }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModalOverlay',
  props: {
    title: String,
    overlay: Boolean,
    closeOnButtonClick: Boolean,
    windowClass: {
      type: String,
      default: '',
    },
    width: String,
    height: String,
    back: Boolean,
    fullscreen: Boolean,
    mainContentPadding: String,
    closeOnOverlayClick: Boolean,
    mainButtonDisabled: Boolean,
    scrollableBackground: {
      type: Boolean,
      default: false,
    },
    callbackFunctions: {
      mainButton: String,
      secondaryButton: String,
    },
    buttonNames: {
      mainButton: String,
      secondaryButton: String,
    },
    buttonClasses: {
      mainButton: Array,
      secondaryButton: Array,
    },
  },
  data() {
    return {
      canCloseModal: [],
    }
  },
  methods: {
    closeModal(element) {
      if (this.canCloseModal.includes(element)) {
        this.$emit('close-modal')
      } else {
        return false
      }
    },
    executeButtonEvent(button, data) {
      if (button === 'mainButton' && this.mainButtonDisabled) return false
      let event = this.callbackFunctions[button]
      this.$emit(event, data)
    },
  },
  mounted() {
    if (this.closeOnButtonClick) {
      this.canCloseModal.push('closeButton')
    }
    if (this.closeOnOverlayClick) {
      this.canCloseModal.push('closeOverlay')
    }
    if (this.overlay && !this.scrollableBackground) {
      document.body.style.overflow = 'hidden'
    }
  },
  unmounted() {
    if (this.overlay && !this.scrollableBackground) {
      document.body.style.overflow = 'auto'
    }
  },
}
</script>

<style scoped>
.modal-window {
  width: 40%;
  z-index: 1;
}
.close-modal-button {
  position: sticky;
}

@media (min-width: 768px) {
  .cityModal {
    min-width: 480px !important;
  }
}

@media only screen and (min-width: 1441px) {
  .modal-window {
    height: 70vh !important;
    width: 35%;
  }
}
@media only screen and (max-width: 1440px) {
  .modal-window {
    height: 70vh !important;
    min-width: 40%;
  }
}
@media only screen and (max-width: 767px) {
  .modal-window {
    width: calc(100% - 2rem);
    max-width: calc(100% - 2rem);
    overflow-y: auto;
  }
}
.modal-window {
  background-color: #fff;
  max-height: 90vh;
}

/*.modal-window__footer {*/
/*  position: fixed;*/
/*  width: inherit;*/
/*  bottom: 0;*/
/*  background-color: #fff;*/
/*  left: 30%;*/
/*}*/
button {
  display: block;
}
</style>
